// src/icons/ChatIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function ChatIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 25,
    viewBox: "0 0 24 25",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx("path", {
        d: "M0 3.92188C0 3.36959 0.447715 2.92188 1 2.92188H23C23.5523 2.92188 24 3.36959 24 3.92188V17.9219C24 18.4742 23.5523 18.9219 23 18.9219H16C15.4477 18.9219 15 18.4742 15 17.9219C15 17.3696 15.4477 16.9219 16 16.9219H22V4.92188H2V16.9219H6C6.55228 16.9219 7 17.3696 7 17.9219V20.0534L11.4453 17.0898C11.9048 16.7835 12.5257 16.9076 12.832 17.3672C13.1384 17.8267 13.0142 18.4476 12.5547 18.7539L6.5547 22.7539C6.24784 22.9585 5.8533 22.9776 5.52814 22.8035C5.20298 22.6295 5 22.2907 5 21.9219V18.9219H1C0.447715 18.9219 0 18.4742 0 17.9219V3.92188Z",
        fill: "currentColor"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M6 8.92188C6 8.36959 6.44772 7.92188 7 7.92188H17C17.5523 7.92188 18 8.36959 18 8.92188C18 9.47416 17.5523 9.92188 17 9.92188H7C6.44772 9.92188 6 9.47416 6 8.92188Z",
        fill: "currentColor"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M7 11.9219C6.44772 11.9219 6 12.3696 6 12.9219C6 13.4742 6.44772 13.9219 7 13.9219H17C17.5523 13.9219 18 13.4742 18 12.9219C18 12.3696 17.5523 11.9219 17 11.9219H7Z",
        fill: "currentColor"
      })
    ]
  });
}
export {
  ChatIcon
};
//# sourceMappingURL=ChatIcon.mjs.map